import { render, staticRenderFns } from "./NuevaProrrogaCA.vue?vue&type=template&id=35c0ec3c&scoped=true"
import script from "./NuevaProrrogaCA.vue?vue&type=script&lang=js"
export * from "./NuevaProrrogaCA.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevaProrrogaCA.vue?vue&type=style&index=2&id=35c0ec3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0ec3c",
  null
  
)

export default component.exports